import React from 'react';

const StatusPill = ({ children }) => <span className="py-1 px-2 bg-grey-darker rounded text-xs text-white uppercase font-bold">{children}</span>;

export default StatusPill;
